import { Observable, of, throwError } from 'rxjs';
import { HttpClient, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { catchError, tap, map } from 'rxjs/operators';
import { Injectable } from '@angular/core';
import { SharedService } from './shared.service';
import{ GlobalConstants } from '../common/global-constants';
const apiUrl = GlobalConstants.apiURL
@Injectable({
  providedIn: 'root'
})
export class SettingService {

  constructor(private http:HttpClient, private sharedapi:SharedService) { }

  addAssignedSetting(data,category_id,circle_id)
  {
    let alldata={
      'data':data,
      'category_id':category_id,
      'circle_id':circle_id
    }
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'add-assigned-setting' ,alldata,{headers:webheader})
  }

  fetchAssignedBdsData(data){
    let circle_id = data.circle_id;
    let category_id = data.category_id;
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-assigned-user-data/'+ circle_id +'/'+category_id,{headers:webheader})
  }

  //==============================Common Setting==============================//
  getcommon_setting_Data()
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.get(apiUrl+'get-common-setting-data',{headers:webheader})
  }

  updateWalletData(data)
  {
      let webheader = this.sharedapi.getHeaders();
      return this.http.post(apiUrl+'update-wallet-setting',data,{headers:webheader})
  }

  updateSmsData(data)
  {
    let webheader = this.sharedapi.getHeaders();
    return this.http.post(apiUrl+'update-sms-setting',data,{headers:webheader})
  }

}
